import { UserManager, WebStorageStateStore, type User } from "oidc-client-ts";
import type { RuntimeConfig } from "../types.js";

/** Build an oidc-client-ts UserManager for Authorization Code + PKCE against the portal pool. */
export function createUserManager(config: RuntimeConfig): UserManager {
  return new UserManager({
    authority: config.cognitoAuthority,
    client_id: config.cognitoClientId,
    redirect_uri: config.redirectUri,
    post_logout_redirect_uri: config.postLogoutRedirectUri,
    response_type: "code", // Authorization Code flow; PKCE is on by default in oidc-client-ts
    scope: config.scope,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    monitorSession: false,
  });
}

export type { User };
